import _ from 'lodash';
import React from 'react';

import {default as Modal, withModal} from 'components/Modal';
import Button from 'components/Button';

import {isModalOpen, MODALS, selectModal} from 'ducks/modals';

import noPermissionIcon from './assets/no-access.svg';
import './styles.css';

const DEFAULT_NO_PERMISSION_MESSAGE =
  "Sorry, but you don't have access permission. Please contact your Line Manager for more details.";

const NoPermissionModal = ({
  closeModal,
  data: {
    noPermissionMessage = DEFAULT_NO_PERMISSION_MESSAGE,
    isOpen,
    disableClose
  }
}: any) => {
  return (
    <Modal
      className="NoPermissionModal"
      modalOverlayClassName="NoPermissionModalOverlay"
      show={isOpen}
      type={Modal.EXTRA_SMALL}
      onClose={closeModal}>
      <Modal.Header heading="No can do ..." />
      <Modal.Body>
        <img src={noPermissionIcon} alt="No permission" />
        <div className="text">{noPermissionMessage}</div>
      </Modal.Body>
      <Modal.Footer>
        {!disableClose && (
          <Button white onClick={closeModal}>
            Okay
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

const mapStateToModalData = state => {
  const modal = selectModal(state, MODALS.NO_PERMISSION);

  return {
    isOpen: isModalOpen(state, MODALS.NO_PERMISSION),
    disableClose: _.get(modal, 'data.disableClose', false)
  };
};

export default withModal(MODALS.NO_PERMISSION, mapStateToModalData)(
  NoPermissionModal
);
